<section class="flex-col gap-12">
  <h2 class="heading-5 mt-12 md-mt-20">Dialog wrapper and how to use it!</h2>

  <app-button dataLabel="standard-confirm" (onClick)="loadConfirmDialog()"> Standard confirm! </app-button>
  <app-button dataLabel="retry" (onClick)="loadRetryDialog()"> Standard Retry dialog! </app-button>
  <app-button dataLabel="custom" (onClick)="loadTemplateDialog(DialogTemplate)">
    Dialog using custom template
  </app-button>
  <ng-template #DialogTemplate>
    <section>I am the content in the template!</section>
  </ng-template>
</section>

<section class="flex-col gap-12 mt-24">
  <h2 class="heading-5">Buttons</h2>

  <app-button
    [buttonOptions]="{
      variant: 'secondary',
    }"
    dataLabel="test-button"
    [loading]="true"
  >
    This is a button!
  </app-button>
</section>
